import { render, staticRenderFns } from "./AnnouncementView.vue?vue&type=template&id=68c2fa0d&scoped=true&"
import script from "./AnnouncementView.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementView.vue?vue&type=script&lang=ts&"
import style0 from "./AnnouncementView.vue?vue&type=style&index=0&id=68c2fa0d&scoped=true&lang=css&"
import style1 from "./AnnouncementView.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2fa0d",
  null
  
)

export default component.exports